import React from 'react';
import { NavLink } from 'react-router-dom';
import ListItem from '../../components/ListItem';
import Typography from '../../components/Typography';
// import '../styles/Sidebar.css';

const Sidebar = ({ isOpen, closeSidebar }) => {
    const navItems = [
        {
            path: '/admin/accounts', label: 'accounts', icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <g clipPath="url(#clip0_498_711)">
                    <path opacity="0.2" d="M10.0005 2.5C8.48322 2.49991 7.00163 2.95999 5.75132 3.81949C4.50101 4.67899 3.54079 5.8975 2.99743 7.31411C2.45408 8.73072 2.35315 10.2788 2.70798 11.754C3.06281 13.2291 3.8567 14.562 4.98483 15.5766C5.45535 14.6507 6.17301 13.8732 7.05829 13.3302C7.94357 12.7871 8.9619 12.4998 10.0005 12.5C9.38239 12.5 8.7782 12.3167 8.2643 11.9733C7.75039 11.63 7.34985 11.1419 7.11333 10.5709C6.87681 9.99987 6.81492 9.37153 6.9355 8.76534C7.05608 8.15915 7.35371 7.60233 7.79075 7.16529C8.22779 6.72825 8.78461 6.43062 9.3908 6.31005C9.99699 6.18947 10.6253 6.25135 11.1963 6.48788C11.7674 6.7244 12.2554 7.12494 12.5988 7.63884C12.9422 8.15275 13.1255 8.75693 13.1255 9.375C13.1255 10.2038 12.7962 10.9987 12.2102 11.5847C11.6241 12.1708 10.8293 12.5 10.0005 12.5C11.0389 12.4997 12.0572 12.787 12.9425 13.3298C13.8277 13.8727 14.5455 14.6501 15.0161 15.5758C16.1439 14.5612 16.9376 13.2284 17.2922 11.7533C17.6469 10.2783 17.5459 8.7304 17.0026 7.31397C16.4592 5.89753 15.4991 4.67916 14.249 3.81969C12.9989 2.96023 11.5175 2.50008 10.0005 2.5Z" fill="white" />
                    <path d="M4.98438 15.5758C5.45462 14.6496 6.17216 13.8716 7.05745 13.3282C7.94275 12.7848 8.96123 12.4972 10 12.4972C11.0388 12.4972 12.0572 12.7848 12.9425 13.3282C13.8278 13.8716 14.5454 14.6496 15.0156 15.5758" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10 12.5C11.7259 12.5 13.125 11.1009 13.125 9.375C13.125 7.64911 11.7259 6.25 10 6.25C8.27411 6.25 6.875 7.64911 6.875 9.375C6.875 11.1009 8.27411 12.5 10 12.5Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_498_711">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        },
        {
            path: '/admin/investments', label: 'Investments', icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <g clipPath="url(#clip0_650_1475)">
                    <path opacity="0.2" d="M16.25 3.125H11.875V16.25H16.25V3.125Z" fill="white" />
                    <path d="M3.75 16.25V10.625H7.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M17.5 16.25H2.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.5 16.25V6.875H11.875" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M11.875 16.25V3.125H16.25V16.25" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_650_1475">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        },
        {
            path: '/admin/notifications', label: 'notificATIONS', icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <g clipPath="url(#clip0_498_870)">
                    <path opacity="0.2" d="M4.37515 8.125C4.37515 6.63316 4.96778 5.20242 6.02267 4.14752C7.07756 3.09263 8.5083 2.5 10.0001 2.5C11.492 2.5 12.9227 3.09263 13.9776 4.14752C15.0325 5.20242 15.6251 6.63316 15.6251 8.125C15.6251 10.9234 16.2736 13.1719 16.7892 14.0625C16.844 14.1574 16.8728 14.2649 16.8729 14.3745C16.873 14.484 16.8444 14.5916 16.7898 14.6865C16.7352 14.7815 16.6566 14.8604 16.5619 14.9154C16.4672 14.9705 16.3597 14.9996 16.2501 15H3.75015C3.64076 14.9993 3.53345 14.97 3.43896 14.9149C3.34448 14.8597 3.26611 14.7808 3.2117 14.6859C3.15729 14.591 3.12874 14.4835 3.12891 14.3741C3.12907 14.2647 3.15795 14.1572 3.21265 14.0625C3.72749 13.1719 4.37515 10.9227 4.37515 8.125Z" fill="white" />
                    <path d="M7.5 17.5H12.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M4.37515 8.125C4.37515 6.63316 4.96778 5.20242 6.02267 4.14752C7.07756 3.09263 8.5083 2.5 10.0001 2.5C11.492 2.5 12.9227 3.09263 13.9776 4.14752C15.0325 5.20242 15.6251 6.63316 15.6251 8.125C15.6251 10.9234 16.2736 13.1719 16.7892 14.0625C16.844 14.1574 16.8728 14.2649 16.8729 14.3745C16.873 14.484 16.8444 14.5916 16.7898 14.6865C16.7352 14.7815 16.6566 14.8604 16.5619 14.9154C16.4672 14.9705 16.3597 14.9996 16.2501 15H3.75015C3.64076 14.9993 3.53345 14.97 3.43896 14.9149C3.34448 14.8597 3.26611 14.7808 3.2117 14.6859C3.15729 14.591 3.12874 14.4835 3.12891 14.3741C3.12907 14.2647 3.15795 14.1572 3.21265 14.0625C3.72749 13.1719 4.37515 10.9227 4.37515 8.125Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_498_870">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        },
        {
            path: '/admin/tickets', label: 'TICKETS', icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <g clipPath="url(#clip0_498_863)">
                    <path d="M10.1875 11.5C10.6017 11.5 10.9375 11.1642 10.9375 10.75C10.9375 10.3358 10.6017 10 10.1875 10C9.77329 10 9.4375 10.3358 9.4375 10.75C9.4375 11.1642 9.77329 11.5 10.1875 11.5Z" fill="white" />
                    <path d="M6.75 11.5C7.16421 11.5 7.5 11.1642 7.5 10.75C7.5 10.3358 7.16421 10 6.75 10C6.33579 10 6 10.3358 6 10.75C6 11.1642 6.33579 11.5 6.75 11.5Z" fill="white" />
                    <path d="M13.625 11.5C14.0392 11.5 14.375 11.1642 14.375 10.75C14.375 10.3358 14.0392 10 13.625 10C13.2108 10 12.875 10.3358 12.875 10.75C12.875 11.1642 13.2108 11.5 13.625 11.5Z" fill="white" />
                    <path opacity="0.2" d="M3.52734 17.6023C3.43631 17.6789 3.32531 17.7279 3.20739 17.7436C3.08947 17.7593 2.96952 17.741 2.86164 17.6909C2.75376 17.6407 2.66242 17.5609 2.59836 17.4606C2.5343 17.3604 2.50018 17.244 2.5 17.125V4.625C2.5 4.45924 2.56585 4.30027 2.68306 4.18306C2.80027 4.06585 2.95924 4 3.125 4H16.875C17.0408 4 17.1997 4.06585 17.3169 4.18306C17.4342 4.30027 17.5 4.45924 17.5 4.625V14.625C17.5 14.7908 17.4342 14.9497 17.3169 15.0669C17.1997 15.1842 17.0408 15.25 16.875 15.25H6.25L3.52734 17.6023Z" fill="white" />
                    <path d="M3.52734 17.9773C3.43631 18.0539 3.32531 18.1029 3.20739 18.1186C3.08947 18.1343 2.96952 18.116 2.86164 18.0659C2.75376 18.0157 2.66242 17.9359 2.59836 17.8356C2.5343 17.7354 2.50018 17.619 2.5 17.5V5C2.5 4.83424 2.56585 4.67527 2.68306 4.55806C2.80027 4.44085 2.95924 4.375 3.125 4.375H16.875C17.0408 4.375 17.1997 4.44085 17.3169 4.55806C17.4342 4.67527 17.5 4.83424 17.5 5V15C17.5 15.1658 17.4342 15.3247 17.3169 15.4419C17.1997 15.5592 17.0408 15.625 16.875 15.625H6.25L3.52734 17.9773Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_498_863">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        },
        {
            path: '/admin/edit-contract-template',
            label: 'CONTRACT COPY',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <g clipPath="url(#clip0_contract_template)">
                        <path
                            opacity="0.2"
                            d="M3.75 3.75V16.25H16.25V6.875H12.5V3.75H3.75Z"
                            fill="white"
                        />
                        <path
                            d="M3.75 3.75V16.25H16.25V6.875H12.5V3.75H3.75Z"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M12.5 3.75V6.875H16.25"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M6.25 7.5H13.75"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M6.25 10H13.75"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M6.25 12.5H10"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8.75 15C9.44036 15 10 14.4404 10 13.75C10 13.0596 9.44036 12.5 8.75 12.5C8.05964 12.5 7.5 13.0596 7.5 13.75C7.5 14.4404 8.05964 15 8.75 15Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_contract_template">
                            <rect width="20" height="20" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
    ];

    return (
        <aside className={`sidebar bg-black text-white lg:relative fixed top-0 lg:left-0 md:left-0 right-0 min-h-screen w-[218px] z-30 transform transition-transform duration-300 sm:transition-none ${isOpen ? 'md:translate-x-0 -translate-x-0' : 'md:-translate-x-full translate-x-full'
            } lg:translate-x-0 lg:w-[218px]`}>
            <div className="flex justify-center px-10 py-4 gap-[50px] items-center self-stretch lg:hidden">
                <div className="flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="24" viewBox="0 0 44 24" fill="none">
                        <mask id="mask0_4548_1728" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="44" height="24">
                            <rect width="44" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_4548_1728)">
                            <path d="M9 15V13.6H35V15H9ZM9 9.4V8H35V9.4H9Z" fill="white" />
                        </g>
                    </svg>
                    <Typography text={'Menu'} color={'#FFF'} size={'16px'} family={'Supply'} transform={'uppercase'} weight={400} lineheight={'170%'} />
                </div>
                <button onClick={closeSidebar}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <g opacity="0.6">
                            <mask id="mask0_4614_10644" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="30">
                                <rect width="30" height="30" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_4614_10644)">
                                <path d="M7.9998 23.3172L6.68262 22L13.6826 15L6.68262 7.99999L7.9998 6.6828L14.9998 13.6828L21.9998 6.6828L23.317 7.99999L16.317 15L23.317 22L21.9998 23.3172L14.9998 16.3172L7.9998 23.3172Z" fill="white" />
                            </g>
                        </g>
                    </svg>
                </button>
            </div>
            <ul className="sidebar-nav">
                {navItems.map((item) => (
                    <NavLink
                        to={item.path}
                        key={item.path}
                        className={({ isActive }) =>
                            isActive ? 'sidebar-link active bg-[#DF0F11]' : 'sidebar-link'
                        }
                    >
                        <ListItem item={item} />
                    </NavLink>
                ))}
            </ul>
        </aside>
    );
};

export default Sidebar;